/* ZTS scroll reveals — ~0.4KB, deferred. Reveals .zts-reveal elements as
   they enter the viewport. Falls back to instantly revealing everything if
   IntersectionObserver is unavailable. Reduced-motion users never see the
   animation (handled in CSS). */
(function () {
  var els = document.querySelectorAll('.zts-reveal');
  if (!els.length) return;

  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('is-revealed'); });
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
  );

  els.forEach(function (el) { io.observe(el); });
})();

/* ---- ZTS text choreography (v2): scroll-lit statements + count-ups.
   Skipped entirely under prefers-reduced-motion (CSS shows final state). ---- */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Scroll-lit statement text */
  document.querySelectorAll('[data-engrave-text]').forEach(function (el) {
    var words = el.textContent.trim().split(/\s+/);
    el.innerHTML = words.map(function (w) { return '<span class="zc-w">' + w + '</span>'; }).join(' ');
    var spans = el.querySelectorAll('.zc-w');
    var ticking = false;
    function update() {
      ticking = false;
      var r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var start = window.innerHeight * 0.8;
      var progress = (start - r.top) / (r.height + window.innerHeight * 0.3);
      progress = Math.max(0, Math.min(1, progress));
      var lit = Math.floor(progress * spans.length * 1.15);
      spans.forEach(function (s, i) { s.classList.toggle('lit', i < lit); });
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  });

  /* Spec count-ups */
  var counters = document.querySelectorAll('[data-count]');
  if (counters.length && 'IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        cio.unobserve(e.target);
        var el = e.target;
        var target = parseFloat(el.getAttribute('data-count'));
        if (isNaN(target)) return;
        var prefix = el.getAttribute('data-prefix') || '';
        var suffix = el.getAttribute('data-suffix') || '';
        var t0 = null, dur = 1100;
        function frame(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / dur, 1);
          p = 1 - Math.pow(1 - p, 3);
          el.textContent = prefix + Math.round(target * p).toLocaleString() + suffix;
          if (p < 1) requestAnimationFrame(frame);
        }
        requestAnimationFrame(frame);
      });
    }, { threshold: 0.6 });
    counters.forEach(function (el) { cio.observe(el); });
  }
})();
